import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight, Home } from 'lucide-react';

// Reduced from uniticket: only the routes the standalone actually serves.
const ROUTE_LABEL_KEYS: Record<string, string> = {
  tickets: 'breadcrumbs.tickets',
  'address-validations': 'breadcrumbs.addressValidations',
  'address-validation': 'breadcrumbs.addressValidation',
  admin: 'breadcrumbs.admin',
  users: 'breadcrumbs.users',
};

export function Breadcrumbs() {
  const location = useLocation();
  const { t } = useTranslation('common');
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;
  // No breadcrumbs on the queue (the home crumb already points there).
  if (segments.length === 1 && segments[0] === 'address-validations') return null;

  const crumbs = segments.map((seg, i) => {
    const path = '/' + segments.slice(0, i + 1).join('/');
    const labelKey = ROUTE_LABEL_KEYS[seg];
    const label = labelKey
      ? t(labelKey)
      : (segments[i - 1] === 'tickets' ? t('breadcrumbs.ticketDetail') : seg);
    const isLast = i === segments.length - 1;
    return { path, label, isLast };
  });

  return (
    <div className="flex items-center gap-2 px-4 md:px-8 py-2.5 bg-slate-100/60 border-b border-slate-200 text-sm">
      <Link to="/address-validations" className="text-brand-rose hover:text-brand-purple transition-colors">
        <Home className="w-4 h-4" />
      </Link>
      {crumbs.map((crumb) => (
        <span key={crumb.path} className="flex items-center gap-2">
          <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
          {crumb.isLast ? (
            <span className="text-slate-600 font-medium">{crumb.label}</span>
          ) : (
            <Link to={crumb.path} className="text-brand-rose hover:text-brand-purple transition-colors">
              {crumb.label}
            </Link>
          )}
        </span>
      ))}
    </div>
  );
}
